// Телефонные утилиты. Бэкенд ожидает нормализованный российский номер `+7XXXXXXXXXX`
// (12 символов). Ввод нормализуем при отправке, а на экране показываем читаемую маску.

/** Нормализует произвольный ввод к виду `+7XXXXXXXXXX` (12 символов) или '' если цифр нет. */
export function normalizePhone(input: string): string {
  let digits = input.replace(/\D/g, '');
  if (!digits) {
    return '';
  }
  // Ведущая 8 → 7 (российский формат), 10 цифр без кода → добавляем 7.
  if (digits.length === 11 && digits.startsWith('8')) {
    digits = `7${digits.slice(1)}`;
  } else if (digits.length === 10) {
    digits = `7${digits}`;
  } else if (!digits.startsWith('7') && !digits.startsWith('8')) {
    digits = `7${digits}`;
  } else if (digits.startsWith('8')) {
    digits = `7${digits.slice(1)}`;
  }
  return `+${digits.slice(0, 11)}`;
}

/**
 * Ссылка для звонка из номера в произвольном виде. Берём только ведущую часть строки, состоящую из
 * цифр и разделителей набора, и убираем из неё оформление. Всё, что идёт после (например «доб. 12»),
 * отбрасываем: приклеенные цифры добавочного дали бы номер другого абонента.
 *
 * <p>К российскому формату номер НЕ приводим — он приходит от стороннего сервера и может быть
 * иностранным; звонилка разберётся с ним лучше, чем наша маска.
 */
export function telHref(phone: string): string {
  const dialable = /^\s*\+?[\d\s()\-.]*/.exec(phone)?.[0] ?? '';
  return `tel:${dialable.replace(/[^\d+]/g, '')}`;
}

const PHONE_RE = /^\+7\d{10}$/;

/** true, если номер нормализуется к валидному `+7XXXXXXXXXX`. */
export function isValidPhone(input: string): boolean {
  return PHONE_RE.test(normalizePhone(input));
}

/**
 * Прогрессивная маска для отображения по мере ввода: `+7 (XXX) XXX-XX-XX`.
 * Толерантна к частичному вводу (не «перепрыгивает» курсор скобками на пустом поле).
 */
export function formatPhone(input: string): string {
  let digits = input.replace(/\D/g, '');
  if (!digits) {
    return '';
  }
  if (digits.startsWith('8')) {
    digits = `7${digits.slice(1)}`;
  }
  if (!digits.startsWith('7')) {
    digits = `7${digits}`;
  }
  const rest = digits.slice(1, 11); // 10 значащих цифр после кода страны
  if (rest.length === 0) {
    return '+7';
  }
  // Разделитель добавляем только когда в следующей группе уже есть цифра — без «висящих» `) ` и `-`.
  let out = `+7 (${rest.slice(0, 3)}`;
  if (rest.length > 3) {
    out += `) ${rest.slice(3, 6)}`;
  }
  if (rest.length > 6) {
    out += `-${rest.slice(6, 8)}`;
  }
  if (rest.length > 8) {
    out += `-${rest.slice(8, 10)}`;
  }
  return out;
}
